import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_pasori_sensor_container = _resolveComponent("pasori-sensor-container")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_pasori_vevo_container = _resolveComponent("pasori-vevo-container")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mb-8" }, [
      _createElementVNode("h1", null, "PaSoRi（パソリ）設定")
    ], -1)),
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
      color: "primary"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, null, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("午睡センサー", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_pasori_sensor_container)
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_pasori_vevo_container)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}